import { render, staticRenderFns } from "./LegalHeader.vue?vue&type=template&id=049a66ac&scoped=true"
import script from "./LegalHeader.vue?vue&type=script&lang=ts"
export * from "./LegalHeader.vue?vue&type=script&lang=ts"
import style0 from "./LegalHeader.vue?vue&type=style&index=0&id=049a66ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049a66ac",
  null
  
)

export default component.exports